// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"edf3bca9","455":"0d4e94ef","977":"335426b2"}[chunkId] + ".chunk.js";
};